export default __webpack_public_path__ + "static/media/seryldas_grudge.065732a7.png";